import React, {useEffect} from 'react'
import './LandingPage.scss';
import OwlCarousel from 'react-owl-carousel2';
import BottomNav from "../../component/BottomNav/BottomNav";
import PollGraph from "../../component/PollGraph/PollGraph";
import InviteCard from "../../component/InviteCard/InviteCard";
import {
	addToHomeScreenModalToggler,
	addToHomeScreenToggler,
	addToHomescreenVisitChecker,
	AddWalletData, fetchAllParties,
	setActivePage, setForgetPin
} from "../../Actions";
import {compose} from "redux";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {fetchQuery} from "relay-runtime";
import environment from "../../Environment";
import StockList from "../../component/StockListing/StockList";
import AllPartyQuery from "../../queries/AllPartyQuery";
import TopGainersLosersQuery from "../../queries/TopGainersLosers";
import UserPortfolioQuery from "../../queries/UserPortfolioQuery";
import UpcommingStocks from "../../component/UpcommingStocks/UpcommingStocks";
import UpcommingStocksQuery from "../../queries/UpcommingStocksQuery";
import CustomNavbar from "../../component/CustomNavbar/CustomNavbar";
import PartiesList from "../../component/PartiesList/PartiesList";
import SectionHeader from "../../component/SectionHeader/SectionHeader";
import Loading from "../../component/Loading";
import {Fade, Slide, Zoom} from 'react-reveal'
import StocksInNewsQuery from "../../queries/StocksInNewsQuery";
import StocksInNewsSlider from "../../component/StocksInNewsSlider/StocksInNewsSlider";
import AllCollectionsQuery from "../../queries/AllCollectionsQuery";
import ReactTooltip from 'react-tooltip';

import AllExpertCornerQuery from "../../queries/AllExpertCornerQuery";
import AllPollsQuery from "../../queries/AllPollsQuery";
import cogoToast from "cogo-toast";
import PollParticipateMutation from "../../mutations/PollParticipateMutation";
import CollectionsComponent from "../../component/Collections/CollectionsComponent";
import WelcomePortfolioCard from "../../component/WelcomePortfolioCard/WelcomePortfolioCard";
import NewUserLandingPageQuery from "../../queries/NewUserLandingPageQuery";
import ScrollToTop from "react-router-scroll-top";
import {NonEmptyArray, numberFormat} from "../../util";
import WalletDataQuery from "../../queries/WalletData";
import AddToHomeScreen from "../../component/AddToHomeScreen/AddToHomeScreen";
import {assetUrl} from "../../serviceApi";
import FeaturedStocksInNewsQuery from "../../queries/FeaturedStocksInNewsQuery";
import StockOwnedCountQuery from "../../queries/StockOwnedCountQuery";
import StockHistoryDetailsQuery from "../../queries/StockHistoryDetailsQuery";
import Skeleton from "react-loading-skeleton";
import VisibilitySensor from "react-visibility-sensor";
import AllPollParticipationQuery from "../../queries/AllPollParticipationQuery";

const briefCase = assetUrl + 'images/new_breifcase_landing_portfolio.png';
const arrow = assetUrl + "images/Icon_Forward_sm.svg";
const star = assetUrl + 'images/Star.png'
const greenUpArrow1 = assetUrl + 'images/landing-portfolio-card-growth.png';
const redDownArrow1 = assetUrl + 'images/red-arrow-sm.svg';
const TopGainersIcon = assetUrl + "images/top-gainers-icon.svg";
const ExpertCornerIcon = assetUrl + "images/expert-corner-icon.svg";
const StockInNewsIcon = assetUrl + "images/stocks-in-news-icon.svg";
const UpcommingStocksIcon = assetUrl + "images/upcomming-stocks-icon.svg";
const PoliticalCareerIcon = assetUrl + "images/political-career-icon.svg";
const CollectionIcon = assetUrl + "images/collection-icons.svg";
const TopLoosersIcon = assetUrl + "images/top-loosers-icon.svg";
const addtoHomeclose = assetUrl + 'images/white-akar-close-large.png'
const addtoHomeModallogo = assetUrl + 'images/addtohome-modal-log.png'

const options2 = {
	items: 2,
	dotsEach: true,
	dots: true,
	rewind: false,
	autoplay: false,
	stagePadding: 1,
	touchDrag: false,
	pullDrag: false
};

// let topLosersLoaded = 0;
// let upcomingStockLoaded = 0;
let inviteCardLoaded = 0;
let allPartiesLoaded = 0;
let pollsLoaded = 0;
let expertCornerLoaded = 0;

class LandingPage extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			partyList: [],
			topGainersStockList: [],
			topLoosersStockList: [],
			portfolioData: {},
			upcomming_stocks: [],
			stocksInNews: [],
			collections: [],
			testimonials: [],
			expertCorners: [],
			allPolls: {},
			quiz_participated: false,
			user_answer: [],
			pollChoices: [],
			newUser: {},
			walletData: {},
			loadingArray: ["loading"],
			// addtoHomeScreen: false,
			installPrompt: false,
			stockOwnedCount: {},
			stockHistoryDetails: [],
			expertCornerVisible: []

			// addToHomescreenModal: false

		}
	}

	// componentWillMount() {
	// 	this.setState({
	// 		partyList: partyList,
	// 		topGainersStockList: this.formateStockData(topGainersStockList),
	// 		topLoosersStockList: this.formateStockData(topLoosersStockList),
	// 		portfolioData:portfolioData,
	// 		upcomming_stocks:upCommingStocks
	// 	});
	// }

	componentDidMount() {
		document.body.style = "overflow-y:auto"
		document.body.style = "overflow-x:hidden"

		inviteCardLoaded = 0;
		allPartiesLoaded = 0;
		pollsLoaded = 0;
		this.props.setActivePage("home");
		this.props.setForgetPin();
		// this.getAllParties();
		// this.getTopLoosersList();
		// this.getUpcommingStocks();
		// this.getAllCollections();
		// // this.getAlltestimonials(); removed
		// this.getAllExpertCorner();
		// this.getAllPolls(true);
		if(this.props.logged_in){
			this.checkNewUser();
		}
		this.iOS();
		this.firstSetQueryFetching();

	}

	firstSetQueryFetching = async () => {
		if(this.props.logged_in) {
			await this.getWalletData();
			await this.getPortfolioData();
			await this.getStockOwnedCount();

		}
		await this.getStockHistoryDetails();
		await this.getStocksInNews();
		await this.getTopGainersList();

	}

	closeAddToHomeScreenPage = () => {
		// this.setState({addtoHomeScreen: false});
		this.props.addtoHomeScreen_Toggle(false)
		if (this.props.addToHomescreenModal === false) {
			setTimeout(() => {
				// this.setState({
				// 	addToHomescreenModal: true
				// })
				this.props.addtoHomeScreenModal_Toggle(true)
			}, 3000)
		}

	}

	InstallPromptChecker = () => {
		if (this.props.addToHomeScreenVistChecker && this.props.addToHomeScreenVistChecker.length === 0) {
			// installPrompt = "fsdf";
			console.log("Listening for Install prompt");
			window.addEventListener('beforeinstallprompt', e => {
				// For older browsers
				e.preventDefault();
				console.log("Install Prompt fired");
				// installPrompt = e;
				this.setState({installPrompt: e})
				// See if the app is already installed, in that case, do nothing
				if ((window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) || window.navigator.standalone === true) {
					return false;
				}
				// Set the state variable to make button visible
				// 			this.setState({addtoHomeScreen: true});
				//		updated with session
				this.props.addtoHomeScreen_Toggle(true)
				this.props.addtoHomeScreen_Visit("checked")
			})

			//	 for testing
			// this.props.addtoHomeScreen_Toggle(true)
			// this.props.addtoHomeScreen_Visit("checked")
		}

	}

	// this is the test ios
	iOS() {
		console.log("checking")
		let isIos = [
				'iPad Simulator',
				'iPhone Simulator',
				'iPod Simulator',
				'iPad',
				'iPhone',
				'iPod'
			].includes(navigator.platform)
			// iPad on iOS 13 detection
			|| (navigator.userAgent.includes("Mac") && "ontouchend" in document)
		if (isIos) {
			console.log("ios")
		} else {
			console.log("not ios")
			this.InstallPromptChecker()
		}
	}

	installApp = async () => {

		if (!this.state.installPrompt) return false;
		this.state.installPrompt.prompt();
		let outcome = await this.state.installPrompt.userChoice;
		if (outcome.outcome === 'accepted') {
			console.log("App Installed")
		} else {
			console.log("App not installed");
		}
		// Remove the event reference
		// installPrompt=null;
		this.setState({installPrompt: null})
		// Hide the button
		// this.setState({
		// 	installButton:false
		// })
		// this.setState({
		// 	addtoHomeScreen: false,
		// 	addToHomescreenModal: false
		// });
		this.props.addtoHomeScreen_Toggle(false)
		this.props.addtoHomeScreenModal_Toggle(false)
	}

	checkNewUser = () => {
		this.updateLoading(true);
		fetchQuery(environment, NewUserLandingPageQuery)
			.toPromise()
			.then(response => {
				this.updateLoading(false);
				if (response.newUserLandingPage !== null) {
					this.setState({
						newUser: response.newUserLandingPage
					})
				} else {
					this.setState({
						newUser: {}
					})
				}
			}, err => {
				this.updateLoading(false);
				console.log(err);
				this.setState({
					newUser: {}
				})
			});
	}

	getAllParties = () => {
		// this.updateLoading(true);
		fetchQuery(environment, AllPartyQuery)
			.toPromise()
			.then(response => {
				// this.updateLoading(false);
				if (NonEmptyArray(response.allParties)) {
					this.setState({
						partyList: response.allParties.edges
					})
					this.props.setAllPartiesToStore(response.allParties.edges)
				} else {
					this.setState({
						partyList: []
					})
				}

			}, err => {
				// this.updateLoading(false);
				console.log(err);
				this.setState({
					partyList: []
				})
			});
	}

	getUpcommingStocks = () => {
		let variables = {}
		this.updateLoading(true);
		fetchQuery(environment, UpcommingStocksQuery, variables)
			.toPromise()
			.then(response => {

				if (NonEmptyArray(response.allPoliticians)) {
					this.setState({
						upcomming_stocks: response.allPoliticians.edges
					})
					if (this.state.upcomming_stocks.length > 0) {
						this.updateLoading(false);
					}
				} else {
					this.setState({
						upcomming_stocks: []
					})
					this.updateLoading(false);
				}

			}, err => {
				this.updateLoading(false);
				console.log(err);
				this.setState({
					upcomming_stocks: []
				})
			});
	}
	getStockHistoryDetails = () => {
		let variables = {
			stockId: ""
		}
		this.updateLoading(true);
		fetchQuery(environment, StockHistoryDetailsQuery, variables)
			.toPromise()
			.then(response => {
				this.updateLoading(false);

				if (response.stockHistoryDetails !== null && Object.keys(response.stockHistoryDetails).length > 0) {

					this.setState({
						stockHistoryDetails: response.stockHistoryDetails
						// stock_list:response.allPoliticians.edges.length>0 ?response.allPoliticians.edges:[]
					})
					// console.log(response.stockHistoryDetails.price_diff)
				} else {
					this.setState({
						stockHistoryDetails: []

					})
				}
			}, err => {
				this.updateLoading(false);
				console.log(err);
				this.setState({
					stockHistoryDetails: []
				})
			});
	}

	getStocksInNews = () => {
		let variables = {
			first:5
		}
		this.updateLoading(true);
		fetchQuery(environment, FeaturedStocksInNewsQuery, variables)
			.toPromise()
			.then(response => {
				this.updateLoading(false);
				if (NonEmptyArray(response.allPoliticians)) {
					this.setState({
						stocksInNews: response.allPoliticians.edges
					})
				} else {
					this.setState({
						stocksInNews: []
					})
				}

			}, err => {
				this.updateLoading(false);
				console.log(err);
				this.setState({
					stocksInNews: []
				})
			});
	}

	getAllCollections = () => {
		let variables = {}
		// this.updateLoading(true);
		fetchQuery(environment, AllCollectionsQuery, variables)
			.toPromise()
			.then(response => {

				if (NonEmptyArray(response.allCollections)) {
					this.setState({
						collections: response.allCollections.edges
					})
					// if (this.state.collections.length > 0) {
					// 	this.updateLoading(false);
					// }
				} else {
					this.setState({
						collections: []
					})
					// this.updateLoading(false);
				}

			}, err => {
				// this.updateLoading(false);
				console.log(err);
				this.setState({
					collections: []
				})
			});
	}

	// getAlltestimonials = () => {
	// 	let variables = {}
	// 	this.updateLoading(true);
	// 	fetchQuery(environment, AllTestimonialsQuery, variables)
	// 		.toPromise()
	// 		.then(response => {
	//
	// 			if (response.allTestimonials !== null && response.allTestimonials.edges.length > 0) {
	// 				this.setState({
	// 					testimonials: response.allTestimonials.edges
	// 				})
	// 				if(this.state.collections.length >0){
	// 					this.updateLoading(false);
	// 				}
	// 			} else {
	// 				this.setState({
	// 					testimonials: []
	// 				})
	// 			}
	// 			this.updateLoading(false);
	// 		}, err => {
	// 			this.updateLoading(false);
	// 			console.log(err);
	// 			this.setState({
	// 				testimonials: []
	// 			})
	// 		});
	// }

	getAllExpertCorner = () => {
		let variables = {}
		this.updateLoading(true);
		console.log("expert corner fired")
		fetchQuery(environment, AllExpertCornerQuery, variables)
			.toPromise()
			.then(response => {

				if (
					// response.allExpertCorner !== null && response.allExpertCorner.edges.length > 0
					NonEmptyArray(response.allExpertCorner)
				) {
					this.setState({
						expertCorners: response.allExpertCorner.edges
					})
					if (this.state.expertCorners.length > 0) {
						this.updateLoading(false);
					}
				} else {
					this.setState({
						expertCorners: []
					})
					this.updateLoading(false);
				}

			}, err => {
				this.updateLoading(false);
				console.log(err);
				this.setState({
					expertCorners: []
				})
			});
	}

	getAllPolls = () => {
		let variables = {}
		// if (show_loading === true) {
		// 	this.updateLoading(true);
		// }
		fetchQuery(environment, AllPollsQuery, variables)
			.toPromise()
			.then(response => {

				if (NonEmptyArray(response.allPolls)) {
					let length = response.allPolls.edges.length
					let nodeData = response.allPolls.edges[length - 1] ? response.allPolls.edges[length - 1].node : {};
					this.setState({
						allPolls: nodeData,
						quiz_participated: nodeData.isCompleted,
						pollChoices: nodeData.pollChoices.edges
						// user_answer: nodeData.pollParticipation.edges.length > 0 ? nodeData.pollParticipation.edges[0].node : {}
					})
					// this.updateLoading(false);

				} else {
					this.setState({
						allPolls: {},
						quiz_participated: false,
						pollChoices: []
						// user_answer: {}

					})

				}
				// if (show_loading === true) {
				// 	this.updateLoading(false);
				// }
			}, err => {
				console.log(err);
				// if (show_loading === true) {
				// 	this.updateLoading(false);
				// }
				this.setState({
					allPolls: {},
					quiz_participated: false,
					pollChoices: []
					// user_answer: {}
				})
			});
	}

	getPollParticipants = () => {
		let variables = {}
		// if (show_loading === true) {
		// 	this.updateLoading(true);
		// }
		fetchQuery(environment, AllPollParticipationQuery, variables)
			.toPromise()
			.then(response => {

				if (NonEmptyArray(response.allPollsParticipants)) {

					this.setState({
						user_answer: response.allPollsParticipants.edges.length > 0 ? response.allPollsParticipants.edges : []
					})
					// this.updateLoading(false);

				} else {
					this.setState({
						user_answer: []

					})

				}
				// if (show_loading === true) {
				// 	this.updateLoading(false);
				// }
			}, err => {
				console.log(err);
				// if (show_loading === true) {
				// 	this.updateLoading(false);
				// }
				this.setState({

					user_answer: []
				})
			});
	}

	getStockOwnedCount = () => {
		let variables = {
			stockId: ""
		}
		this.updateLoading(true);
		fetchQuery(environment, StockOwnedCountQuery, variables)
			.toPromise()
			.then(response => {
				this.updateLoading(false);
				if (response.stockOwnedCount !== null && Object.keys(response.stockOwnedCount).length > 0) {
					this.setState({
						stockOwnedCount: response.stockOwnedCount
						// stock_list:response.allPoliticians.edges.length>0 ?response.allPoliticians.edges:[]
					})
					// console.log(response.allPoliticians.edges)
				} else {
					this.setState({
						stockOwnedCount: {}

					})
				}
			}, err => {
				this.updateLoading(false);
				console.log(err);
				this.setState({
					stockOwnedCount: {}
				})
			});
	}

	getTopGainersList = () => {
		let variables = {
			gainers: true,
			first: 5
		}
		this.updateLoading(true);
		fetchQuery(environment, TopGainersLosersQuery, variables)
			.toPromise()
			.then(response => {

				if (response.topGainersLosers !== null && response.topGainersLosers.length > 0) {

					this.setState({
						topGainersStockList: this.formateStockData(response.topGainersLosers)
					})
				} else {
					this.setState({
						topGainersStockList: []
					})
				}
				this.updateLoading(false);
			}, err => {
				this.updateLoading(false);
				console.log(err);
				this.setState({
					topGainersStockList: []
				})
			});
	}

	getTopLoosersList = () => {
		let variables = {
			gainers: false,
			first: 5
		}
		this.updateLoading(true);
		fetchQuery(environment, TopGainersLosersQuery, variables)
			.toPromise()
			.then(response => {

				if (response.topGainersLosers !== null && response.topGainersLosers.length > 0) {
					this.setState({
						topLoosersStockList: this.formateStockData(response.topGainersLosers)
					})
				} else {
					this.setState({
						topLoosersStockList: []
					})
				}
				this.updateLoading(false);
			}, err => {
				this.updateLoading(false);
				console.log(err);
				this.setState({
					topLoosersStockList: []
				})
			});
	}

	formateStockData = (response) => {
		let stockList = [];
		let res_data = response;
		for (let i = 0; i < res_data.length; i++) {
			stockList[i] = {
				id: res_data[i].stock.id,
				name: res_data[i].stock.name,
				party_name: res_data[i].stock.party.partyName,
				price: res_data[i].stock.price,
				// stockOwned change
				// stocks_owned: res_data[i].stock.stockOwnedCount,
				price_diffrence: res_data[i].profitLoss,
				politicianImage: res_data[i].stock.politicianImage
			}
		}
		return stockList;
	}

	getPortfolioData = () => {
		let variables = {}
		this.updateLoading(true);
		fetchQuery(environment, UserPortfolioQuery, variables)
			.toPromise()
			.then(response => {

				if (response.userPortfolio !== null) {
					this.setState({
						portfolioData: response.userPortfolio
					})
				} else {
					this.setState({
						portfolioData: {}
					})
				}
				this.updateLoading(false);
			}, err => {
				this.updateLoading(false);
				console.log(err);
				this.setState({
					portfolioData: {}
				})
			});
	}

	getWalletData = () => {
		let variables = {
			userId: this.props.user_details.user.id
		}
		this.updateLoading(true);
		fetchQuery(environment, WalletDataQuery, variables)
			.toPromise()
			.then(response => {
				this.updateLoading(false);
				if (NonEmptyArray(response.allWallet)) {
					// props.setWalletData(response.allWallet.edges[0].node);
					this.setState({
						walletData: response.allWallet.edges[0].node
					})
					this.props.addWalletData(response.allWallet.edges[0].node)

				}
			}, err => {
				this.updateLoading(false);
				console.log(err);
				this.setState({
					walletData: {}
				})
				this.props.addWalletData({})

			});
	}

	updateLoading = (action) => {
		let tmp_loading_array = this.state.loadingArray;
		if (action) {
			tmp_loading_array.push("loading");
		} else {
			tmp_loading_array.pop();
		}
		this.setState({
			loadingArray: tmp_loading_array
		})
	}

	submitPollResult = (answer) => {
		let data = {
			pollId: this.state.allPolls.id,
			answerId: answer.node.id
		}
		let scope = this;

		// this.updateLoading(true);
		PollParticipateMutation(data, function (response) {
			// scope.updateLoading(false);
			if (response.pollParticipate && response.pollParticipate.participation.id) {
				cogoToast.success(response.pollParticipate.message, {position: 'top-center'});
				scope.getAllPolls(false);
			} else {
				cogoToast.error(response.pollParticipate.message, {position: 'top-center'});
			}
		}, function (err) {
			console.log(err);
			// scope.updateLoading(false);
			cogoToast.error(err, {position: 'top-center'});
		});

	}


	render() {
		const styleLanding = "landing-";
		// let tempPortfolioValue = 0
		return (

			// <Loading loading={this.state.loadingArray.length > 1}>
			<ScrollToTop>
				{
					this.props.addtoHomeScreen ?
						<AddToHomeScreen submit={this.installApp}
						                 close={this.closeAddToHomeScreenPage}/>
						:
						<div className={styleLanding + "page-main"}>
							{
								this.props.addToHomescreenModal !== false &&
								<div className={"add-to-home-modal"}>
									<div className={'d-flex align-items-center'} onClick={this.installApp}>
										<img src={addtoHomeModallogo} alt={"alt"}
										     className={"addToHomeModal_logo mr-3"}/>
										<div>
											<p className={"title mb-1"}>NETA</p>
											<p className={"text mb-0"}>Add Widget to Homescreen</p>
										</div>
									</div>

									<img src={addtoHomeclose} className={"icon"} alt={"alt"}
									     onClick={() => this.props.addtoHomeScreenModal_Toggle(false)}/>

								</div>
							}

							<CustomNavbar page={"main"}
							              walletData={this.state.walletData}
							              // loading={Object.keys(this.state.walletData).length < 1}
										  loading={this.state.loadingArray.length > 1}
							              newUser={this.state.newUser.newUserPortfolio}
							/>
							<div id={"Landing_mainWrapper"} className={"landing-main-wrapper"}>
								{/*{*/}
								{/*	this.state.stocksInNews.length > 0 &&*/}
								<div className={styleLanding + "stocks-list"}
								     style={{marginTop: 0}}>
									<SectionHeader heading={"Trending Politicians"} image={StockInNewsIcon}
									               viewmore={true}
									               redirect={"/all-stocks/news"}/>
									{
										(this.state.stocksInNews.length !== 0) ?
											<div className={"stocks-in-news-section"}>
												{/*<StocksInNewsSlider stock_data={this.state.stocksInNews}/>*/}
												<StockList stock_list={this.state.stocksInNews}
												           stock_history_details={this.state.stockHistoryDetails}
												           stock_owned_count={this.state.stockOwnedCount}/>
											</div>
											:
											<div style={{marginBottom: "24px"}}>
												<Skeleton count={5} height={"50px"}/>
											</div>

									}
								</div>
								{/*}*/}
								{
									this.state.topGainersStockList.length > 0 &&
									<div className={"top-gainers-section"}>
										<SectionHeader heading={"Top Gainers"} image={TopGainersIcon}
										               viewmore={true}
										               redirect={'/all-stocks'} topGainerFilter={true}/>
										{
											// this.state.topGainersStockList.length > 0 && !(this.state.loadingArray.length > 1) ?
											<div className={"stock-list-section"}>
												<StockList stock_list={this.state.topGainersStockList}
												           stock_owned_count={this.state.stockOwnedCount}
												           stock_history_details={this.state.stockHistoryDetails}
												/>
											</div>
											// : <Skeleton count={5} height={"50px"}/>
										}
									</div>
								}
								{

									// <Slide bottom distance={"1px"}>
									<div className={"portfolio-card-wrappper"}>
										{
											this.state.newUser.newUserPortfolio || !this.props.logged_in ?
												<WelcomePortfolioCard/> :
												Object.keys(this.state.portfolioData).length === 0 ?
													<Skeleton width={"100%"} height={"150px"}
													          style={{marginTop: "24px"}}/>
													:

													<div className={styleLanding + "portfolio-card"}
													     style={{position: 'relative'}}>
														<p className={styleLanding + "portfolio-card-text mb-2"}>
															PORTFOLIO VALUE
														</p>

														<p className={styleLanding + "portfolio-card-price mb-1"}>
															{/*{(this.state.loadingArray.length > 1) ? 0 : */}
															{numberFormat(this.state.portfolioData.marketCurrentTotal)}
														</p>

														{

															//this.state.portfolioData.percentageDiff
															//tempPortfolioValue
															parseFloat(this.state.portfolioData.percentageDiff) !== 0 &&
															<div className={'d-flex'}><p
																className={styleLanding + "portfolio-card-value " + (this.state.portfolioData.percentageDiff > 0 ? "positive" : "negative ")}>{Math.abs(this.state.portfolioData.percentageDiff ? this.state.portfolioData.percentageDiff : 0)}%</p>
																<img
																	src={this.state.portfolioData.percentageDiff >= 0 ? greenUpArrow1 : redDownArrow1}
																	alt={'alt'}
																	className={styleLanding + "arrow-icon"}
																	style={{
																		width: "12px",
																		height: "12px",
																		objectFit: "contain"
																	}}/>
															</div>
														}

														<div className={'d-flex align-items-center mt-4'}
														     style={{marginTop: "13px"}}
														     onClick={() => this.props.history.push("/portfolio")}>
															<p
																className={styleLanding + "portfolio-card-portfolio"}>View
																Portfolio</p>
															<img src={arrow} alt={'alt'}
															     className={styleLanding + "arrow-icon"}/>
														</div>

														<div
															className={styleLanding + "portfolio-card-imageWrapper"}>
															{/*<Fade delay={1000}>*/}
															<img alt={"alt"} src={briefCase}
															     className={styleLanding + "portfolio-card-image"}/>
															{/*</Fade>*/}
															{/*<Zoom delay={1000}>*/}
															<img alt={"alt"} src={star}
															     className={styleLanding + "portfolio-card-starImage animate__animated animate__bounce animate__delay-2s"}/>
															{/*</Zoom>*/}
														</div>
													</div>
										}
									</div>

									// </Slide>
								}

								{/*<Fade bottom>*/}
								<div className={"invite-card-section"}>
									<VisibilitySensor>
										{({isVisible}) => {

											if (isVisible && inviteCardLoaded === 0) {

												inviteCardLoaded = inviteCardLoaded + 1
												this.getAllCollections();
												this.getTopLoosersList()
											}

											return <InviteCard/>
										}}
									</VisibilitySensor>
								</div>
								{/*</Fade>*/}
								{
									this.state.collections.length > 0 &&
									<div className={styleLanding + "collections collection-section"}>
										<VisibilitySensor>
											{({isVisible}) => {

												if (isVisible && allPartiesLoaded === 0) {

													allPartiesLoaded = allPartiesLoaded + 1
													this.getAllParties();
													this.getUpcommingStocks()
												}

												return <SectionHeader heading={"Groups"} image={CollectionIcon}
												                      viewmore={true}
												                      redirect={"/all-collections"}/>
											}}
										</VisibilitySensor>
										<div className={"collection-list-section"}>
											<CollectionsComponent collection_data={this.state.collections}/>
										</div>
									</div>
								}
								{
									this.state.topLoosersStockList.length > 0 &&
									<div className={styleLanding + "stocks-list top-loosers-section"}>
										<SectionHeader heading={"Top Losers"} image={TopLoosersIcon} viewmore={true}
										               redirect={"/all-stocks"} topLoserFilter={true}/>
										<div className={"top-loosers-list-section"}>
											<StockList stock_list={this.state.topLoosersStockList}
											           stock_history_details={this.state.stockHistoryDetails}
											           stock_owned_count={this.state.stockOwnedCount}/>
										</div>
									</div>
								}
								{/*{*/}
								{/*	this.state.partyList.length > 0 &&*/}
								<div className={styleLanding + "politics political-parties-section"}>
									<VisibilitySensor>
										{({isVisible}) => {

											if (Object.keys(this.state.allPolls).length === 0 && isVisible && pollsLoaded === 0) {

												pollsLoaded = pollsLoaded + 1
												this.getAllPolls(true);
												if(this.props.logged_in){
													this.getPollParticipants();
												}
												this.getAllExpertCorner();

											}

											return <SectionHeader heading={"Explore Parties"}
											                      image={PoliticalCareerIcon}
											                      viewmore={false}/>
										}}
									</VisibilitySensor>
									<div className={"political-party-list-section"}>
										{
											this.state.partyList.length > 0 ?
												<PartiesList part_data={this.state.partyList}/>
												:
												<div className={'d-flex'}>
													<Skeleton width={"176px"} height={"142px"}
													          style={{marginRight: "12px"}}/>
													<Skeleton width={"176px"} height={"142px"}
													          style={{marginRight: "12px"}}/>
												</div>

										}

									</div>
								</div>
								{/*}*/}
								{/*{*/}
								{/*	this.state.scrollNav && <div className={styleLanding + "addmoney-card"}>*/}
								{/*		<div className={styleLanding + "addmoney-pattern d-flex justify-content-between"}>*/}
								{/*			<div>*/}
								{/*				<p className={styleLanding + "addmoney-card-text"}>Add Money to Your Wallet*/}
								{/*					to*/}
								{/*					<span*/}
								{/*						style={{*/}
								{/*							color: "white",*/}
								{/*							fontWeight: 700*/}
								{/*						}}> Purchase Neta Shares </span>*/}
								{/*				</p>*/}
								{/*				<div className={'d-flex align-items-end'}*/}
								{/*				     onClick={() => this.props.history.push("/wallet")}>*/}
								{/*					<p className={styleLanding + "addmoney-card-portfolio "}>Add Money</p>*/}
								{/*					<img src={whiteArrow} alt={'alt'}*/}
								{/*					     className={styleLanding + "arrow-icon "}/>*/}
								{/*				</div>*/}
								{/*			</div>*/}
								{/*			{!(this.state.loading > 0) && <Zoom>*/}
								{/*				<div className={styleLanding + "addmoney-card-image-wrap"}>*/}
								{/*					/!*<img alt={"alt"} src={wallet_addmoney} className={styleLanding + "addmoney-card-image"}/>*!/*/}
								{/*					<img alt={"alt"} src={wallet_addmoney_wallet}*/}
								{/*					     className={styleLanding + "addmoney-card-image-wallet"}/>*/}
								{/*					/!*<img alt={"alt"} src={wallet_addmoney_star}*!/*/}
								{/*					/!*     className={styleLanding + "addmoney-card-image-star"}/>*!/*/}
								{/*					/!*<img alt={"alt"} src={wallet_addmoney_bg}*!/*/}
								{/*					/!*     className={styleLanding + "addmoney-card-image-bg"}/>*!/*/}
								{/*				</div>*/}
								{/*			</Zoom>}*/}

								{/*		</div>*/}
								{/*	</div>*/}
								{/*}*/}

								{
									this.state.upcomming_stocks.length > 0 &&
									<div className={styleLanding + "stocks-list"}>
										<SectionHeader heading={"Neta IPO"} image={UpcommingStocksIcon}
										               viewmore={true}
										               tooltip={"upcoming"}
										               redirect={"/all-stocks/upcomming"}/>
										{/*<Fade bottom cascade>*/}
										<div className={"upcomming-stocks-list-section"}>
											<UpcommingStocks stock_data={this.state.upcomming_stocks}/>
										</div>
										{/*</Fade>*/}
									</div>
								}

								{/* all polls -------------------- temp hidden */}
								{
									Object.keys(this.state.allPolls).length !== 0 &&
										<div className={"poll-graph-section"}
										     style={this.state.expertCorners.length === 0 ? {marginBottom: "120px"} : {marginBotom: 0}}>

											{/*<Fade bottom>*/}
											<VisibilitySensor>
												{({isVisible}) => {

													if (this.state.expertCorners.length === 0 && isVisible && expertCornerLoaded === 0) {

														expertCornerLoaded = expertCornerLoaded + 1
														// this.getAllExpertCorner();
													}
													console.log("visiblitySensor", isVisible)

													return <PollGraph
														poll_data={this.state.allPolls}
														quiz_participated={this.state.quiz_participated}
														user_answer={this.state.user_answer}
														pollChoices={this.state.pollChoices}
														submitPollResult={this.submitPollResult}
														pollResult={false}
													/>
												}}
											</VisibilitySensor>
											{/*</Fade>*/}

										</div>
										// :
										// <Skeleton height={'296px'} width={'100%'} style={{marginTop: '48px'}}/>
								}

								{/*{*/}
								{/*	this.state.expertCorners.length > 0 &&*/}

								{/**/}
								{this.state.expertCorners.length > 0 &&
								<div className={styleLanding + "expert pb-4  expert-corner-section"}>
									<SectionHeader heading={"Expert Corner"} image={ExpertCornerIcon}
									               viewmore={true}
									               redirect={"/extend"}/>

									<div className={"expert-corner-list-section"}>

										{
											this.state.expertCorners.length > 0 ?
												// <Slide right>
												<OwlCarousel options={options2}>
													{
														this.state.expertCorners.map((item, index) => {
															return (
																<div
																	className={styleLanding + "expert-card mr-3"}
																	key={index}>
																	<a href={item.node.link}>
																		<div
																			className={"expert-corner-image"}
																			style={{
																				background: `url(${item.node.expertCornerImage}), rgba(82, 82, 82, 0.1)`
																			}}/>
																		<p className={styleLanding + 'expert-text'}>{item.node.shortDescription}</p>
																		<p className={styleLanding + 'expert-subtext'}>{item.node.source}</p>
																	</a>
																</div>
															);
														})
													}
												</OwlCarousel>
												// </Slide>
												:
												<div className={'d-flex'}>
													<Skeleton width={"176px"} height={"142px"}
													          style={{marginRight: "12px"}}/>
													<Skeleton width={"176px"} height={"142px"}
													          style={{marginRight: "12px"}}/>
												</div>
										}

									</div>

								</div>}

								<div className={"bottom-space"}/>

								<div className={styleLanding + 'appbarWrap'}>
									<BottomNav/>
								</div>
							</div>
						</div>
				}
			</ScrollToTop>
			// </Loading>
		);
	}

}

const mapStateToProps = state => ({
		user_details: state.UserReducer.user_details,
		addtoHomeScreen: state.UserReducer.addtoHomeScreen,
		addToHomescreenModal: state.UserReducer.addToHomescreenModal,
		addToHomeScreenVistChecker: state.UserReducer.addToHomeScreenVistChecker,
		logged_in: state.UserReducer.logged_in
	}

)

const mapDispatchToProps = dispatch => (
	{
		setActivePage: data => dispatch(setActivePage(data)),
		addWalletData: data => dispatch(AddWalletData(data)),
		addtoHomeScreenModal_Toggle: data => dispatch(addToHomeScreenModalToggler(data)),
		addtoHomeScreen_Toggle: data => dispatch(addToHomeScreenToggler(data)),
		addtoHomeScreen_Visit: data => dispatch(addToHomescreenVisitChecker(data)),
		setForgetPin: () => dispatch(setForgetPin(false)),
		setAllPartiesToStore:(data)=>dispatch(fetchAllParties(data))
	}
)

export default compose(
	withRouter,
	connect(mapStateToProps, mapDispatchToProps)
)(LandingPage)
